import { BookingStatus } from 'generated/graphql'

// A supplier can replace the driver until the driver arrives at the collection
export const isSupplierAllowedToReplaceDriver = (status: BookingStatus) =>
  [
    BookingStatus.Quotation,
    BookingStatus.EBooking,
    BookingStatus.Waiting,
    BookingStatus.Allocated,
    BookingStatus.PackageOnBoardOnWay,
    BookingStatus.Declined,
  ].includes(status)

// A supplier can remove the driver only before the booking is accepted
export const isSupplierAllowedToDeleteDriver = (status: BookingStatus) =>
  [BookingStatus.Quotation, BookingStatus.EBooking, BookingStatus.Waiting].includes(status)
